import { LangCodes } from '@tsl-frontend/tsl-locale';
import { PRIMARY_YEAR_GROUPS } from '@consts';
import { regionAppConfig } from '@locales';

import { User } from '@types';

export const isPrimaryStudent = (user: User | null) =>
    user && PRIMARY_YEAR_GROUPS.includes(user.year_id);

export const isUKStudent = () => regionAppConfig.userRegion === LangCodes.GB;
